import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import { reducer as formReducer } from 'redux-form';
import thunk from 'redux-thunk';

import auth from './auth/reducer';
import files, { getSearchFilter } from './files/reducer';
import circles, { getSelectedCircles } from './circles/reducer';
import types, { getSelectedTypes } from './types/reducer';
import years, { getSelectedYears } from './years/reducer';
import funds, { getSelectedFunds } from './funds/reducer';
import notifications from './notifications/reducer';
import data from './data/reducer';

const rootReducer = combineReducers({
	form: formReducer,
	auth,
	files,
	circles,
	types,
	years,
	funds,
	notifications,
	data,
});

const store = createStore(
	rootReducer,
	compose(
		applyMiddleware(thunk),
		window.devToolsExtension ? window.devToolsExtension() : f => f
	)
)

export default store;

export const anyActiveFilters = state => {
	const search  = !!getSearchFilter(state.files);
	const circles = getSelectedCircles(state.circles).length;
	const types   = getSelectedTypes(state.types).length;
	const years   = getSelectedYears(state.years).length;
	const funds   = getSelectedFunds(state.funds).length;

	if (search || circles || types || years || funds) {
		return true;
	}
	return false;
}


// WEBPACK FOOTER //
// ./src/store/index.js